<template>
  <div class="health-container" v-if="documentData">
    <div class="health-container-header" @click="handleBack">返回报告首页</div>
    <div class="health-container-content">
      <div class="supplement-container">
        <img :src="`${imgHost2}/yybjfm_pic2.png`" class="supplement-container-bg" />

        <div class="supplement-container-header">
          根据您的疾病风险和骨健康状况，我们向您推荐以下营养保健品：
        </div>
        <div class="supplement-container-content">
          <div class="supplement-container-content-suggestion mb-5">
            <div class="supplement-container-content-suggestion-title">
              根据您的健康状态，建议您适当补充：
            </div>
            <div class="supplement-container-content-suggestion-content">
              <div v-for="item in documentData.health_products" :key="item" class="ai-health-table-item">
                {{ item }}
              </div>
            </div>
          </div>
          <div class="supplement-container-content-mention">
            注：请注意相关安全注意事项，在医生指导下正确服用
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReportDetail } from '@/utils/axios';
import { imgHost2 } from '@/config';


export default {
  name: 'HaleonBackDetailHealth',

  data () {
    return {
      documentData: null,
      imgHost2
    };
  },

  mounted () {
    const id = this.$route.query.id;
    console.log("detail page id: ", id);
    if (id) {
      this.getDetail(id);
    }
  },

  methods: {
    getDetail (id) {
      getReportDetail({ id }).then(res => {
        if (res.code === 200) {
          const data = JSON.parse(window.atob(res.data));
          console.log(data);
          this.documentData = data;
        } else {
          console.log(res.msg);
        }
      })
    },
    handleBack () {
      this.$router.replace({ name: 'archivesDetailIndex', query: { id: this.$route.query.id } });
    },
  },
};
</script>


<style lang="scss" scoped>
.health-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  gap: 10px;
  padding: 10px;
  background-color: #F2F4FA;

  >div {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &-header {
    background-color: #e2e2e2;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: bold;
    user-select: none;
    cursor: pointer;
    color: #000;
  }

  &-content {

    .supplement-container {
      position: relative;
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: 72px 1fr;

      &-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }

      &-header {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 30px;
        font-weight: bold;
        font-size: 16px;
        color: #282a2c;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      &-content {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 30px;
        padding-top: 48px;

        &-title {
          position: relative;
          width: 100%;
          height: fit-content;
          font-weight: bold;
          font-size: 16px;
          color: #282a2c;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          .text-green {
            color: #00b050;
          }
        }

        &-product {
          position: relative;
          width: 100%;
          height: fit-content;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-template-rows: repeat(1, 1fr);
          grid-gap: 12px;

          &-item {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;

            &-pic {
              position: relative;
              width: 100%;
            }

            &-title {
              position: relative;
              width: 100%;
              height: fit-content;
              font-weight: bold;
              font-size: 18px;
              color: #282a2c;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        &-suggestion {
          position: relative;
          width: 100%;
          padding: 15px;
          background-image: linear-gradient(to bottom, #9ad9f9, #f5fbfe);
          border-radius: 8px;

          &-title {
            position: relative;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            color: #282a2c;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          &-content {
            padding: 10px;
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;
          }
        }

        &-mention {
          position: relative;
          width: 100%;
          font-weight: 600;
          font-size: 14px;
          color: #ed6969;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .ai-health-table-item {
        font-weight: bold;
      }
    }
  }
}
</style>